import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {CDN_FEATURES} from "./cdn-features";
import {
  NotificationDialogComponent
} from "../../../../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {TextUtils} from "../../../../../../shared/utils/text-utils";
import {DialogService} from "../../../../../../../ng2-bootstrap-modal/dialog.service";
import {filter, first, takeUntil} from "rxjs/operators";
import {NotifierComponent} from "../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../shared/components/notifier/notification-type";
import {CloudflareService} from "../../../services/cloudflare.service";
import {ActivatedRoute} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../store';
import {map} from "rxjs/operators";
import {Subject} from "rxjs";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-cdn-feature-stack',
    templateUrl: './cdn-feature-stack.component.html',
    styleUrls: ['./cdn-feature-stack.component.scss'],
    standalone: false
})
export class CdnFeatureStackComponent implements OnInit, OnDestroy {

  public websiteId: number;
  public features = CDN_FEATURES;
  public loading: boolean;
  public cdnDisabled: boolean;
  public pageCacheDisabled: boolean;
  public isStatusPending: boolean;
  public showEntCDNTooltip: boolean;

  private readonly _destroyStream = new Subject<boolean>();

  constructor(
    private readonly _dialogService: DialogService,
    private readonly _cloudflareService: CloudflareService,
    private readonly _route: ActivatedRoute,
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _cdr: ChangeDetectorRef,
    private readonly _googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit() {
    this.websiteId = +this._route.snapshot.parent.parent.params['id'];
    this._getCloudflareData();
    /*this._getCloudFlareFullPageCacheDisabled();
    this._getCloudFlareEnterPriseDisabled();*/
  }

  ngOnDestroy() {
    this._destroyStream.next(true);
    this._destroyStream.complete();
  }

  private _getCloudflareData(): void {
    this._store.select(fromStore.getCloudflareData(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream),
        filter(({cacheRules}) => !!cacheRules),
        map(({cacheRules}) => cacheRules),
      )
      .subscribe(({disableCdn, disablePageCache}) => {
        this.cdnDisabled = disableCdn;
        this.pageCacheDisabled = disablePageCache;
        this.loading = false;
        this._cdr.markForCheck();
      });
    this._store.select(fromStore.getCloudflareData(this.websiteId))
      .pipe(
        filter(({cfStatus}) => !!cfStatus),
        map(({cfStatus}) => cfStatus === 'pending')
      )
      .subscribe((status) => {
      this.isStatusPending = status;
    });
  }

  /*private _getCloudFlareFullPageCacheDisabled(): void {
    this._store.select(fromStore.getCloudFlareFullPageCacheDisabled(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream),
      )
      .subscribe(state => {
        this.pageCacheDisabled = !!state;
      });
  }

  private _getCloudFlareEnterPriseDisabled(): void {
    this._store.select(fromStore.getCloudFlareEnterPriseDisabled(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream),
      )
      .subscribe(state => {
        this.cdnDisabled = !!state;
      })
  }*/

  public toggleCDN(): void {
    this.showEntCDNTooltip = true;
    if (this.cdnDisabled) {
      this.sendEvent('Dashboard Action', 'Enterprise CDN On');
      this._toggleCDN(false);
    } else {
      this._openDisableCdnDialog();
    }
  }


  private _openDisableCdnDialog(): void {
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_disableCdn'),
      message: TextUtils.getText('text_disableCdnDesc'),
      buttonText: TextUtils.getText('text_disableBtnDialogText'),
      buttonColor: 'red',
      action: 'disable',
      showCancelButton: true,
      hasCloseButton: true
    })
      .subscribe((confirmed: string): void => {
        if (confirmed && confirmed === 'disable') {
          this.cdnDisabled = true;
          this.sendEvent('Dashboard Action', 'Enterprise CDN Off');
          this._toggleCDN(true);
        }
      });
  }

  private _toggleCDN(state: boolean): void {
    this.loading = true;
    this._cdr.markForCheck();
    this._cloudflareService.toggleCDN(this.websiteId, state)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        this.loading = false;
        this.sendEvent('Dashboard Action', !!state ? 'CDN Enterprise Disabled' : 'CDN Enterprise Enabled');
        if (response.success) {
          NotifierComponent.notify(new Notification(`CDN ${!!state ? 'Disabled' : 'Enabled'}`, NotificationType.SUCCESS));
          this._store.dispatch(new fromStore.SetToggleEnterPriceCDNDisabled({websiteId: this.websiteId, cdnDisabled: !!state}));
        } else {
          NotifierComponent.notify(new Notification('Something Went Wrong...', NotificationType.DANGER));
        }
      });
  }

  public togglePageCache(): void {
    if (this.pageCacheDisabled) {
      this.pageCacheDisabled = false;
      this.sendEvent('Dashboard Action', 'Page Cache On');
      this._togglePageCache(false);
    } else {
      this._openDisablePageCacheDialog();
    }
  }

  private _openDisablePageCacheDialog(): void {
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_disableCloudflare'),
      message: TextUtils.getText('text_disableCloudflareDesc'),
      buttonText: TextUtils.getText('text_disableBtnDialogText'),
      buttonColor: 'red',
      action: 'disable',
      showCancelButton: true,
      hasCloseButton: true
    })
      .subscribe((confirmed: string): void => {
        if (confirmed && confirmed === 'disable') {
          this.pageCacheDisabled = true;
          this.sendEvent('Dashboard Action', 'Page Cache Off');
          this._togglePageCache(true);
        }
      });
  }

  private _togglePageCache(state: boolean): void {
    this.loading = true;
    this._cloudflareService.cacheToggle(this.websiteId, state)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        this.loading = false;
        this.sendEvent('Dashboard Action', !!state ? 'Page Cache Off' : 'Page Cache On');
        if (response.success) {
          this._store.dispatch(new fromStore.SetFullPageCacheDisabled({websiteId: this.websiteId, fullPageCacheDisabled: !!state}));
          NotifierComponent.notify(new Notification(`Page Cache ${!!state ? 'Disabled' : 'Enabled'}`, NotificationType.SUCCESS));
        } else {
          NotifierComponent.notify(new Notification('Something Went Wrong...', NotificationType.DANGER));
        }
      });
  }


  public sendEvent(category: string, action: string): void {
    const analyticsData = {
      eventCategory: category,
      eventAction: action,
      eventLabel: 'Cloudflare',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
